<div class="pk-ad-wrap">
    <a target="_blank" class="btn btn-primary" [href]="downloadUrl">{{ buttonText }}</a>
</div>
